import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

export interface PdfRepository {
  fetch(url: string, params?: object): Observable<void>;
  fetchDirectDebitPdf(url: string): Observable<MSafeAny>;
}

export const PDF_REPOSITORY = new InjectionToken<PdfRepository>('PDF_REPOSITORY');
